import {Injectable} from '@angular/core';
import {FormControl} from '@angular/forms';
import {AttractionHttpService} from '../http/attraction.http';
import {AttractionMaintenanceHttpService} from '../http/maintenance.http';
import {PartHttpService} from '../http/part.http';
import {UnitHttpService} from '../http/unit.http';
import {Attraction, AttractionResponse} from '../types/attraction';
import {Change} from '../types/base';
import {Maintenance, MaintenanceResponse} from '../types/maintenance';
import {Part, PartResponse} from '../types/part';
import {Unit, UnitResponse} from '../types/unit';
import {NavigationStart, Router, RouterEvent} from "@angular/router";


@Injectable({
  providedIn: 'root'
})
export class ReviewService {

  public showBanner: boolean = false
  constructor(private router: Router) {
    // @ts-ignore
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        this.showBanner = false
      }
    });
  }


}
